import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import A1 from "../Images/WhatsApp Image 2026-01-20 at 12.46.23 PM.jpeg";

const AgencyLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch("https://taaiappapi.emedha.in/pages/api/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || "Login failed");
        return;
      }

      sessionStorage.setItem("isLoggedIn", "true");
      sessionStorage.setItem("userEmail", data.user.email);
      sessionStorage.setItem("role", data.user.role);

      alert("Login successful!");
      navigate("/agency-dashboard");

    } catch (err) {
      console.error(err);
      setError("Server error. Try again later.");
    }
  };



  return (
    <div className="login-page">
      <div className="login-card">
        <img src={A1} alt="Logo" className="logo" />
        <h2>Travel Agents Association of India</h2>
        <p>Membership ID Card Application Login</p>

        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && <p className="error">{error}</p>}
          <button type="submit" className="btn-primary">
            Login
          </button>
        </form>
      </div>

      <style>{`
        .login-page {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
          background: #f5f7fa;
          font-family: 'Inter', system-ui;
        }

        .login-card {
          background: white;
          padding: 40px 30px;
          border-radius: 12px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.1);
          text-align: center;
          width: 100%;
          max-width: 400px;
        }

        .login-card .logo {
          height: 70px;
          margin-bottom: 20px;
          border-radius: 8px;
        }

        .login-card h2 {
          margin: 0;
          font-size: 20px;
          color: #111827;
        }

        .login-card p {
          color: #6b7280;
          margin-bottom: 25px;
          font-size: 14px;
        }

        form {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        input {
          padding: 10px 12px;
          border-radius: 6px;
          border: 1px solid #d1d5db;
          font-size: 14px;
        }

        .btn-primary {
          background: #2563eb;
          color: white;
          border: none;
          padding: 10px;
          border-radius: 6px;
          cursor: pointer;
          font-weight: 500;
          transition: all 0.2s;
        }

        .btn-primary:hover {
          background: #1d4ed8;
        }

        .error {
          color: #dc2626;
          font-size: 13px;
        }
      `}</style>
    </div>
  );
};

export default AgencyLogin;
